import { useFeatureFlags } from '../../../services/featureFlags/hooks/useFeatureFlags';
import { ProtectedRoute } from './ProtectedRoute';

type Props = {
  flag: keyof ReturnType<typeof useFeatureFlags>;
  redirectPath?: string;
};

/**
 * Route only accessible if a specific feature flag is enabled
 *
 * @param {keyof FeatureFlags} flag - the feature flag required for access
 * @param {string} [redirectPath] - the path to navigate to if not allowed (default is '/')
 * @returns ProtectedRoute
 */
export function FeatureFlaggedRoute({ flag, redirectPath }: Props) {
  const flags = useFeatureFlags();
  const isAllowed = Boolean(flags[flag]);

  return <ProtectedRoute isAllowed={isAllowed} redirectPath={redirectPath} />;
}
